// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const ChevronDown: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
            <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.05"
                d="M9.692 4.205 6.175 7.722a.246.246 0 0 1-.348 0s0 0 0 0L2.31 4.205"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export const ChevronDownOffset: IconOffset = {
    vertical: 29, // Store Custom Code
    horizontal: 13, // Store Custom Code
};

export default React.memo(ChevronDown);
